// Paints each Color swatch with that variant's own already-uploaded photo, instead of
// Shopify's native color/pattern taxonomy (which has no entry for print names like
// "Floral" or "Leopard Print" and would leave those swatches blank).
//
// Painted two ways:
// - On initial page load, directly against the live DOM.
// - Via <product-info>'s own addPreProcessCallback hook, which runs on the freshly
//   fetched replacement content WHILE IT IS STILL DETACHED, before product-info.js
//   inserts it (see assets/global.js's HTMLUpdateUtility.viewTransition — it inserts the
//   new node immediately and only display:none's + removes the old one 500ms later, no
//   native view-transition crossfade involved). Painting only after insertion (e.g. via a
//   MutationObserver reacting to the DOM change) means the new swatch is visible for a
//   frame or two with no photo yet, then the photo pops in — reads as a brief
//   double-image flash for a photographic swatch (Dawn's own flat-color swatches don't
//   show this gap, since a plain color has nothing to visibly "pop in"). Painting before
//   insertion avoids that: the photo is already there in the very first visible frame.
//
// Also paints --swatch-focal-point from each image's own Shopify-set focal point (see
// product-variant-picker.liquid), same mechanism Dawn's native snippets/swatch.liquid
// uses. component-product-variant-picker.css's fixed "top center" crop is a reasonable
// default, but any specific photo that crops badly under that default (e.g. a full-body
// shot with both feet crossing in frame) can be corrected by setting that image's focal
// point in Shopify — no further code change needed per photo.
function paintPhotoSwatches(root) {
  const dataEl = root.querySelector('[data-variant-images]');
  if (!dataEl) return;

  let variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }

  root.querySelectorAll('fieldset[data-option-name]').forEach((fieldset) => {
    if (!/^(colou?r|kleur)$/i.test(fieldset.dataset.optionName || '')) return;
    const position = Number(fieldset.dataset.optionPosition) - 1;
    if (Number.isNaN(position)) return;

    fieldset.querySelectorAll('.swatch-input__input').forEach((input) => {
      const match = variants.find((v) => v.options[position] === input.value && v.image);
      if (!match) return;
      const swatch = input.nextElementSibling?.querySelector('.swatch');
      if (!swatch) return;
      swatch.style.setProperty('--swatch--background', `url(${match.image})`);
      if (match.focalPoint) {
        swatch.style.setProperty('--swatch-focal-point', match.focalPoint);
      } else {
        swatch.style.removeProperty('--swatch-focal-point');
      }
      swatch.classList.remove('swatch--unavailable');
    });
  });
}

// `root` here can be a <variant-selects> itself, or an ancestor (<product-info>, <main>)
// containing one or more — matches whatever node HTMLUpdateUtility.viewTransition is
// currently swapping in, across product-info.js's different call sites.
function paintPhotoSwatchesWithin(root) {
  if (root.matches?.('variant-selects')) paintPhotoSwatches(root);
  root.querySelectorAll?.('variant-selects').forEach(paintPhotoSwatches);
}

document.querySelectorAll('product-info').forEach((productInfo) => {
  const paintAll = () => paintPhotoSwatchesWithin(productInfo);

  paintAll();
  productInfo.addPreProcessCallback?.(paintPhotoSwatchesWithin);
  new MutationObserver(paintAll).observe(productInfo, { childList: true, subtree: true });
});
